/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/prefer-default-export */
import { useTranslation } from 'react-i18next';

const MIN_CARACTERES_ID = 'cant-characters' as string;
const TEXT_ID = 'level-span' as string;
const MAYUSCULAS_ID = 'up-less-letters' as string;
const HAS_NUMBERS_ID = 'numbers-recomendation' as string;
const CARACTERES_IGUALES_ID = 'not-include-equal-letters' as string;
const HAS_SPECIALS_ID = 'specials-recomendatios' as string;
const RECONOCIBLE_ID = 'not-easy-recognise' as string;
const NIVEL_ID = 'security_level' as string;
const VACIO_CLASS = 'barra__vacio' as string;
const BAJO_CLASS = 'barra__bajo' as string;
const MEDIO_CLASS = 'barra__medio' as string;
const ALTO_CLASS = 'barra__alto' as string;
const OK_CLASS = 'ok' as string;
const NOT_OK_CLASS = 'no-ok' as string;
const NOT_THE_SAME_ID = 'not-the-same' as string;

const EMPTY_LEVEL = 0 as number;
const LOW_LEVEL = 1 as number;
const MID_LEVEL = 2 as number;
const HIGH_LEVEL = 3 as number;

export class SemaforoHelper {
  static setSemaforo = (
    newPassValue: string,
    textVacio: string,
    textBajo: string,
    textMedio: string,
    textAlto: string,
    currentPassValue: string,
  ) => {
    const estaVacio = SemaforoHelper.estaVacio(newPassValue);
    const cumpleMinimos = SemaforoHelper.cumpleMinimos(
      newPassValue,
      currentPassValue,
    );
    const matchAnyRecomendation = SemaforoHelper.matchAnyRecomendation(
      newPassValue,
    );

    if (estaVacio) {
      SemaforoHelper.setLevel(
        EMPTY_LEVEL,
        textAlto,
        textMedio,
        textBajo,
        textVacio,
      );
    } else {
      if (cumpleMinimos) {
        if (matchAnyRecomendation) {
          SemaforoHelper.setLevel(
            HIGH_LEVEL,
            textAlto,
            textMedio,
            textBajo,
            textVacio,
          );
        } else {
          SemaforoHelper.setLevel(
            MID_LEVEL,
            textAlto,
            textMedio,
            textBajo,
            textVacio,
          );
        }
      } else {
        SemaforoHelper.setLevel(
          LOW_LEVEL,
          textAlto,
          textMedio,
          textBajo,
          textVacio,
        );
      }
    }
  };

  private static setLevel(
    level: number,
    textAlto: string,
    textMedio: string,
    textBajo: string,
    textVacio: string,
  ) {
    const barraNivelElem = document.getElementById(NIVEL_ID);
    const textElem = document.getElementById(TEXT_ID);

    switch (level) {
      default: {
        break;
      }
      case EMPTY_LEVEL: {
        if (barraNivelElem) {
          barraNivelElem.classList.add(VACIO_CLASS);
          barraNivelElem.classList.remove(BAJO_CLASS);
          barraNivelElem.classList.remove(MEDIO_CLASS);
          barraNivelElem.classList.remove(ALTO_CLASS);
        }
        if (textElem) {
          textElem.innerText = textVacio;
        }
        break;
      }
      case LOW_LEVEL: {
        if (barraNivelElem) {
          barraNivelElem.classList.remove(VACIO_CLASS);
          barraNivelElem.classList.add(BAJO_CLASS);
          barraNivelElem.classList.remove(MEDIO_CLASS);
          barraNivelElem.classList.remove(ALTO_CLASS);
        }
        if (textElem) {
          textElem.innerText = textBajo;
        }
        break;
      }
      case MID_LEVEL: {
        if (barraNivelElem) {
          barraNivelElem.classList.remove(VACIO_CLASS);
          barraNivelElem.classList.add(MEDIO_CLASS);
          barraNivelElem.classList.remove(BAJO_CLASS);
          barraNivelElem.classList.remove(ALTO_CLASS);
        }
        if (textElem) {
          textElem.innerText = textMedio;
        }
        break;
      }
      case HIGH_LEVEL: {
        if (barraNivelElem) {
          barraNivelElem.classList.remove(VACIO_CLASS);
          barraNivelElem.classList.add(ALTO_CLASS);
          barraNivelElem.classList.remove(BAJO_CLASS);
          barraNivelElem.classList.remove(MEDIO_CLASS);
        }
        if (textElem) {
          textElem.innerText = textAlto;
        }
        break;
      }
    }
  }

  static estaVacio(newPassValue: string) {
    return newPassValue === undefined || newPassValue.length === 0;
  }

  static cumpleMinimos(newPassValue: string, currentPassValue: string) {
    const numCaracteresOk = SemaforoHelper.setMinCharacteres(newPassValue);
    const mayusculasOk = SemaforoHelper.setCapitals(newPassValue);
    const repetidosAndConsecutivosOk = SemaforoHelper.setRepetedAndSequential(
      newPassValue,
    );
    const tesauroOk = SemaforoHelper.setIsInTesauro(newPassValue);
    const notTheSamePass = SemaforoHelper.setNotTheSamePass(
      newPassValue,
      currentPassValue,
    );
    return (
      numCaracteresOk &&
      mayusculasOk &&
      repetidosAndConsecutivosOk &&
      tesauroOk &&
      notTheSamePass
    );
  }

  private static matchAnyRecomendation(newPassValue: string) {
    const hasNumbers = SemaforoHelper.setHasNumbers(newPassValue);
    const hasSpecials = SemaforoHelper.setHasSpecialCharacters(newPassValue);
    return hasNumbers || hasSpecials;
  }

  private static setIsInTesauro(newPassValue: string) {
    const isInTesauroElement = document.getElementById(RECONOCIBLE_ID);
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      isInTesauroElement,
    );
    if (isNotInformed) {
      return false;
    }
    if (newPassValue.length >= 3) {
      const tesauroString = sessionStorage.getItem('tesauro');
      const tesauroJson = tesauroString ? JSON.parse(tesauroString) : null;
      const { palabras } = tesauroJson;
      const { contiene } = tesauroJson;
      const chars = { á: 'a', é: 'e', í: 'i', ó: 'o', ú: 'u' };
      let correctedPass = newPassValue.toLowerCase();
      correctedPass = correctedPass.replace(/[áéíóú]/g, (m) => chars[m]);
      correctedPass = correctedPass.replace('ñ', '&ntilde;');
      const palabrasList = palabras.split('||');
      const contieneList = contiene.split('||');
      const isInPalabrasList = palabrasList.includes(correctedPass);
      const isInContieneList = contieneList.some((element: string) => {
        return element && element.length > 0 && correctedPass.includes(element);
      });
      let ok: boolean;
      if (!isInPalabrasList && !isInContieneList) {
        SemaforoHelper.setOkStyles(isInTesauroElement);
        ok = true;
      } else {
        SemaforoHelper.setNotOkStyles(isInTesauroElement);
        ok = false;
      }
      return ok;
    } else {
      if (isInTesauroElement) {
        isInTesauroElement.classList.remove(OK_CLASS);
        isInTesauroElement.classList.remove(NOT_OK_CLASS);
      }
      return false;
    }
  }

  private static setMinCharacteres(newPassValue: string) {
    const minCaracterselem = document.getElementById(MIN_CARACTERES_ID);
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      minCaracterselem,
    );
    if (isNotInformed) {
      return false;
    }
    if (newPassValue.length >= 8) {
      SemaforoHelper.setOkStyles(minCaracterselem);
      ok = true;
    } else {
      SemaforoHelper.setNotOkStyles(minCaracterselem);
      ok = false;
    }
    return ok;
  }

  private static setCapitals(newPassValue: string) {
    const mayusculasElem = document.getElementById(MAYUSCULAS_ID);
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      mayusculasElem,
    );
    if (isNotInformed) {
      return false;
    }
    const reg = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])/);
    if (reg.test(newPassValue)) {
      SemaforoHelper.setOkStyles(mayusculasElem);
      ok = true;
    } else {
      SemaforoHelper.setNotOkStyles(mayusculasElem);
      ok = false;
    }
    return ok;
  }

  private static setRepetedAndSequential(newPassValue: string) {
    const repetidosElem = document.getElementById(CARACTERES_IGUALES_ID);
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      repetidosElem,
    );
    if (isNotInformed) {
      return false;
    }
    const reg = new RegExp(
      /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|012|123|234|345|456|567|678|789)+/gi,
    );
    const regConsecutivos = new RegExp(/(.)\1\1/);
    if (!reg.test(newPassValue) && !regConsecutivos.test(newPassValue)) {
      SemaforoHelper.setOkStyles(repetidosElem);
      ok = true;
    } else {
      SemaforoHelper.setNotOkStyles(repetidosElem);
      ok = false;
    }
    return ok;
  }

  private static setHasNumbers(newPassValue: string) {
    const hasNumbersElement = document.getElementById(HAS_NUMBERS_ID);
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      hasNumbersElement,
    );
    if (isNotInformed) {
      return false;
    }
    const reg = new RegExp(/\d/);
    if (reg.test(newPassValue)) {
      SemaforoHelper.setOkStyles(hasNumbersElement);
      ok = true;
    } else {
      SemaforoHelper.removeOkStyles(hasNumbersElement);
      ok = false;
    }
    return ok;
  }

  private static setHasSpecialCharacters(newPassValue: string) {
    const hasSpecialCharactersElement = document.getElementById(
      HAS_SPECIALS_ID,
    );
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      hasSpecialCharactersElement,
    );
    if (isNotInformed) {
      return false;
    }
    const reg = new RegExp(/^(?=.*[ºª!”@·#~%&/()=?’¿¡*+^`¨,])/g);
    if (reg.test(newPassValue)) {
      SemaforoHelper.setOkStyles(hasSpecialCharactersElement);
      ok = true;
    } else {
      SemaforoHelper.removeOkStyles(hasSpecialCharactersElement);
      ok = false;
    }
    return ok;
  }

  private static setNotTheSamePass(
    newPassValue: string,
    currentPassValue: string,
  ) {
    const notTheSamePassElem = document.getElementById(NOT_THE_SAME_ID);
    let ok = false;
    const isNotInformed = SemaforoHelper.resetStylesAndReturnIfSizeIsZero(
      newPassValue,
      notTheSamePassElem,
    );

    if (isNotInformed) {
      return false;
    }

    if (newPassValue !== currentPassValue) {
      SemaforoHelper.setOkStyles(notTheSamePassElem);
      ok = true;
    } else if (newPassValue === currentPassValue) {
      SemaforoHelper.setNotOkStyles(notTheSamePassElem);
      ok = false;
    }

    return ok;
  }

  private static resetStylesAndReturnIfSizeIsZero(
    newPassValue: string,
    element: HTMLElement | null,
  ) {
    if (newPassValue === null || newPassValue.length === 0) {
      if (element) {
        element.classList.remove(OK_CLASS);
        element.classList.remove(NOT_OK_CLASS);
      }
      return true;
    } else {
      return false;
    }
  }

  private static setOkStyles(element: HTMLElement | null) {
    if (element) {
      element.classList.remove(NOT_OK_CLASS);
      element.classList.add(OK_CLASS);
    }
  }

  private static setNotOkStyles(element: HTMLElement | null) {
    if (element) {
      element.classList.remove(OK_CLASS);
      element.classList.add(NOT_OK_CLASS);
    }
  }

  private static removeOkStyles(element: HTMLElement | null) {
    if (element) {
      element.classList.remove(OK_CLASS);
    }
  }
}
